{
  "title": "Aktivitätsverfolgung",
  "manageFiltersButton": "Filter verwalten",
  "refreshButton": "Neu laden",
  "exportReportButton": "Bericht exportieren",
  "ariaLabel": "Aktivitäts-Tabs",
  "tabs": {
    "weeklyActivity": "Wochenaktivität",
    "recentActivity": "Letzte Aktivität",
    "fboActivity": "FBO-Aktivität"
  },
  "dialog": {
    "title": "Aktivitätsfilter verwalten"
  },
  "errors": {
    "loadFailed": "Aktivitätsdaten laden fehlgeschlagen"
  }
}
